<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_st9"
      :custom="{storage: true}"
      export
      :refresh="{query: RefreshList}"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('CollectionRecord_search_button')"
          type="primary"
          @click="funcFilter()"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('synchronization_CollectionRecord_button')"
          @click="CloudData()" 
        >
          同步收款记录
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      resizable
      stripe
      highlight-current-row
      border
      show-footer
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :loading="loading"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column
        type="checkbox"
        width="60"
        fixed="left"
      />
      <vxe-table-column>
        <vxe-table-column
          field="transNo"
          title="入账流水号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.transNo"
            placeholder="请输入⼊账流水号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payerCardName"
          title="付款方户名"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.payerCardName"
            placeholder="请输入付款方户名"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payerCardNo"
          title="付款方卡号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.payerCardNo"
            placeholder="请输入付款方卡号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payeeCardName"
          title="收款方户名"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.payeeCardName"
            placeholder="请输入收款方户名"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payeeCardNo"
          title="收款方卡号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.payeeCardNo"
            placeholder="请输入收款方卡号"
            clearable
          />
        </template>
      </vxe-table-column>
      
      <vxe-table-column>
        <vxe-table-column
          field="totalAmount"
          title="收款金额（元）"
          width="220"
          sortable
        />
        <template v-slot:header>
          <div class="for-input-range">
            <el-input
              v-model="listQuery.totalAmountStart"
              placeholder="下限"
              clearable
              @input="(value)=>formFormatter.isFloor2(value,oldValue,listQuery,'totalAmountStart')"
            />
            <el-input
              v-model="listQuery.totalAmountEnd"
              placeholder="上限"
              clearable
              @input="(value)=>formFormatter.isFloor2(value,oldValue,listQuery,'totalAmountEnd')"
            />
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="status"
          :formatter="formatterstatus"
          title="收款状态"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.status"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isConfirmed"
          :formatter="formatterisConfirmed"
          title="是否确认"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isConfirmed"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in isConfirmedOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="refundableAmount"
          title="可退款金额"
          width="220"
          sortable
        />
        <template v-slot:header>
          <div class="for-input-range">
            <el-input
              v-model="listQuery.refundableAmountStart"
              placeholder="下限"
              clearable
              @input="(value)=>formFormatter.isFloor2(value,oldValue,listQuery,'refundableAmountStart')"
            />
            <el-input
              v-model="listQuery.refundableAmountEnd"
              placeholder="上限"
              clearable
              @input="(value)=>formFormatter.isFloor2(value,oldValue,listQuery,'refundableAmountEnd')"
            />
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="refundCount"
          title="退款中"
          width="220"
          sortable
        />
        <template v-slot:header>
          <div class="for-input-range">
            <el-input
              v-model="listQuery.refundCountStart"
              placeholder="下限"
              clearable
              @input="(value)=>formFormatter.isFloor2(value,oldValue,listQuery,'refundCountStart')"
            />
            <el-input
              v-model="listQuery.refundCountEnd"
              placeholder="上限"
              clearable
              @input="(value)=>formFormatter.isFloor2(value,oldValue,listQuery,'refundCountEnd')"
            />
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column
        title="操作"
        fixed="right"
        min-width="150"
      >
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('collection_confirmation_button') && scope.row.isConfirmed == 0 " 
            class="item"
            effect="dark"
            content="确认收款"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="confirmReceiptDate(scope.row)"
            >
              <i class="el-icon-thumb" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('refund_record_button')&& scope.row.isConfirmed == 1"
            class="item"
            effect="dark"
            content="退款"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funRefund(scope.row.code)"
            >
              <i class="el-icon-price-tag" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('refundRecord_record_button')&& scope.row.isConfirmed == 1"
            class="item"
            effect="dark"
            content="退款记录"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="showModel(scope.row, 'RefundRecord')"
            >
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="modelRefundRecordFlag"
      width="1200"
      height="80%"
      title="退款记录"
      resize
    >
      <CompRefundRecord ref="RefundRecordRef" />
    </vxe-modal>
    <vxe-modal
      v-model="modelRefundFlag"
      title="退款"
      width="600"
      height="350"
      resize
    >
      <CompRefund
        ref="RefundRef"
        @fatherRefundMethod="fatherRefund"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script> 
//   import compAdd from "./components/CodingAdd.vue";
  import CompRefundRecord from "./components/RefundRecord.vue";
  import CompRefund from "./components/refund.vue";
  import { CollectionRecord,syncCloudData,confirmReceipt } from "@/api/collectioncoding"; 
  import { isNumber } from "@/utils/validate.js";
  export default {
      components: {
        CompRefundRecord,
        CompRefund
    },
    data() {
      return {
        message: "",
        compTitle:"新增收款编码",
        loading: false,
        tableData: [],
        modelEditFlag:false,
        modelRefundRecordFlag:false,
        modelRefundFlag:false,
        listQuery: {    
          transNo:"",
          payerCardName:"",
          payerCardNo:"",
          payeeCardName:"",
          payeeCardNo:"",
          totalAmountStart:"",
          totalAmountEnd:"",
          status:"",
          isConfirmed:"",
          refundableAmountStart:"",
          refundableAmountEnd:"",
          refundCountStart:"",
          refundCountEnd:"",
          pageNum: 1,
          pageSize: 20,
          sortField: "",
          sortType: "",
          total: 0
        },
        statusOptions: [
          {
            label: "进行中",
            value: "PROCESS"
          },
          {
            label: "成功",
            value: "SUCCESS"
          },
          {
            label: "失败",
            value: "FAIL"
          }
        ],
        isConfirmedOptions: [
          {
            label: "未确认",
            value: 0
          },{
            label: "已确认",
            value: 1
          }
          
        ],
        // Pagingconf: [],
        sumObject: {},
      };
    },
    created() {
      this.findList();
    },
    methods: {
    //确认收款
    confirmReceiptDate(row) {
      this.$confirm("请确认是否收款?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
            const code = row.code
          confirmReceipt({code}).then((response) => { 
            this.$message({
              type: "success",
              message: response.msg,
            });
            this.findList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    //同步收款记录
    CloudData(){
        this.loading = true;
        syncCloudData().then((response) => {
            this.$message({
            message: response.msg,
            type: "success",
            });
            this.findList();
        });
    },
    // 编辑组件的父方法
    fatherRefund() {
      this.modelRefundFlag = false;
      this.findList();
    },
    // 展示弹框
    showModel(code, prefix) {
      if (code) {
        this.$refs[`${prefix}Ref`].findList(code);
      }
      this[`model${prefix}Flag`] = true;
    },
     // 公共取消
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case "edit":
          this.modelEditFlag = false;
          break;
        case "Refund":
         this.modelRefundFlag = false;
         break;
      }
    },
     funRefund(data) {
      this.$refs.RefundRef.getInfo(data);
      this.modelRefundFlag = true;
    },
      isNumber4listQuery(key) {
        let val = this.listQuery[key];
        if (val !== "") {
          if (!isNumber(val)) {
            this.$message({ message: "请输入数字！", type: "error" });
          }
          val = parseFloat(val);
          if (isNaN(val)) {
            val = "";
          }
          this.$set(this.listQuery, key, val);
        }
      },
      formatterstatus({ cellValue }) {
        switch (cellValue) {
          case "PROCESS":
            return "进行中";
          case "SUCCESS":
            return "成功";
          case "FAIL":
            return "失败";
          default:
            break;
        }
      },
      formatterisConfirmed({ cellValue }) {
        switch (cellValue) {
          case 0:
            return "未确认";
          case 1:
            return "已确认";
          default:
            break;
        }
      },
      findList() {
        this.loading = true;
        return new Promise(resolve => {
          CollectionRecord(this.listQuery).then(response => {
            this.tableData = response.data.records;
            // response.data.total>10000? this.Pagingconf = [20, 30, 50, 100,10000]:this.Pagingconf = [20, 30, 50, 100, response.data.total || 1];
            this.listQuery.total = response.data.total;
            this.sumObject = response.data.sumObject;
            this.loading = false;
            resolve();
          });
        });
      },
      handlePageChange({ currentPage, pageSize }) {
        this.listQuery.pageNum = currentPage;
        this.listQuery.pageSize = pageSize;
        this.findList();
      } 
    }
  };
</script>

<style>
</style>
